export type TaskFieldFlags = {
  tags: boolean;
  priority: boolean;
  sections: boolean;
};

export const ALL_TASK_FIELD_FLAGS: TaskFieldFlags = {
  tags: true,
  priority: true,
  sections: true,
};

function asBool(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

export function parseTaskFieldFlags(
  input: Partial<TaskFieldFlags> | null | undefined,
): TaskFieldFlags {
  return {
    tags: asBool(input?.tags, true),
    priority: asBool(input?.priority, true),
    sections: asBool(input?.sections, true),
  };
}
